import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';
import { MERCURE_OPENING_STATUS } from '~/const/orders';
import { FAST_TIMER } from '~/const/timers';
import ProductCard from '~/components/molecules/Global/ProductCard.vue';

const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'AddToCartModal',
  components: {
    MdmModal,
    ProductCard
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      quantity: 1,
      show: false,
      btnDisabled: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    cartItems: 'customer/cartItems',
    items: 'cart/items',
    success: 'cart/success'
  }), {
    productName() {
      return this.product.line ? "".concat(this.product.line, " - ").concat(this.product.name) : this.product.name;
    },

    openingStatus() {
      return this.$cookies.get('MDM_TEST_MERCURE') || MERCURE_OPENING_STATUS[this.locale.iso];
    },

    cartUrl() {
      return this.buildCartUrl(this.locale, this.openingStatus);
    },

    quantityTracking() {
      return {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_quantite',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    },

    showError() {
      if (this.openingStatus) {
        return !this.success;
      }

      return false;
    }

  }),
  watch: {
    showModal() {
      if (this.showModal) {
        if (this.openingStatus) {
          const item = this.items[this.product.reference] || {};
          this.quantity = item.quantity || 1;
        } else {
          this.quantity = this.cartItems[this.product.reference] || 1;
        }
      }
    }

  },
  methods: _objectSpread({}, mapActions({
    updateCart: 'customer/updateCart',
    updateCartMercure: 'cart/updateCart'
  }), {
    debounceUpdateQty: debounce(function updateCartQuantity(event) {
      let updateCartAction = this.updateCart;

      if (this.openingStatus) {
        updateCartAction = this.updateCartMercure;
      }

      updateCartAction({
        reference: this.product.reference,
        quantity: this.quantity
      }).then(() => {
        this.btnDisabled = false;
      });
      this.trackQuantityChange(event);
    }, FAST_TIMER),

    decrementQuantity() {
      if (parseInt(this.quantity, 10) <= 1) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) - 1;
    },

    incrementQuantity() {
      if (parseInt(this.quantity, 10) >= 30) {
        return;
      }

      this.quantity = parseInt(this.quantity, 10) + 1;
    },

    trackQuantityChange(event) {
      this.$root.$emit('generic-tracking', event, this.quantityTracking);
    }

  })
};